import { Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${Color.Gray100};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: ${AppZIndex.LoadingScreen};
  inset: 0;
  position: fixed;
`;
